import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.Boolean
import kotlin.Double
import kotlin.String
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface TripMapControllerTargetLifecycleHooks {
  public fun mapTargetConnected(element: HTMLElement) {
  }

  public fun mapTargetDisconnected(element: HTMLElement) {
  }

  public fun itineraryPointTargetConnected(element: HTMLElement) {
  }

  public fun itineraryPointTargetDisconnected(element: HTMLElement) {
  }

  public fun placePointTargetConnected(element: HTMLElement) {
  }

  public fun placePointTargetDisconnected(element: HTMLElement) {
  }

  public fun itineraryButtonTargetConnected(element: HTMLElement) {
  }

  public fun itineraryButtonTargetDisconnected(element: HTMLElement) {
  }

  public fun placesButtonTargetConnected(element: HTMLElement) {
  }

  public fun placesButtonTargetDisconnected(element: HTMLElement) {
  }

  public fun dayButtonTargetConnected(element: HTMLElement) {
  }

  public fun dayButtonTargetDisconnected(element: HTMLElement) {
  }

  public fun dayPickerTargetConnected(element: HTMLElement) {
  }

  public fun dayPickerTargetDisconnected(element: HTMLElement) {
  }

  public fun cityPickerTargetConnected(element: HTMLElement) {
  }

  public fun cityPickerTargetDisconnected(element: HTMLElement) {
  }

  public fun cityButtonTargetConnected(element: HTMLElement) {
  }

  public fun cityButtonTargetDisconnected(element: HTMLElement) {
  }

  public fun zoomValueChanged(`value`: Double, previousValue: Double) {
  }

  public fun initialModeValueChanged(`value`: String, previousValue: String) {
  }

  public fun initialLatValueChanged(`value`: String, previousValue: String) {
  }

  public fun initialLngValueChanged(`value`: String, previousValue: String) {
  }
}

public fun <T : HTMLElement> TripMapController.mapTarget(): StimulusProperty<T> =
    StimulusProperty("mapTarget")

public fun <T : HTMLElement> TripMapController.mapTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("mapTargets")

public fun <T : HTMLElement> TripMapController.itineraryPointTarget(): StimulusProperty<T> =
    StimulusProperty("itineraryPointTarget")

public fun <T : HTMLElement> TripMapController.itineraryPointTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("itineraryPointTargets")

public fun <T : HTMLElement> TripMapController.placePointTarget(): StimulusProperty<T> =
    StimulusProperty("placePointTarget")

public fun <T : HTMLElement> TripMapController.placePointTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("placePointTargets")

public fun <T : HTMLElement> TripMapController.itineraryButtonTarget(): StimulusProperty<T> =
    StimulusProperty("itineraryButtonTarget")

public fun <T : HTMLElement> TripMapController.itineraryButtonTargets(): StimulusProperty<Array<T>>
    = StimulusProperty("itineraryButtonTargets")

public fun <T : HTMLElement> TripMapController.placesButtonTarget(): StimulusProperty<T> =
    StimulusProperty("placesButtonTarget")

public fun <T : HTMLElement> TripMapController.placesButtonTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("placesButtonTargets")

public fun <T : HTMLElement> TripMapController.dayButtonTarget(): StimulusProperty<T> =
    StimulusProperty("dayButtonTarget")

public fun <T : HTMLElement> TripMapController.dayButtonTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("dayButtonTargets")

public fun <T : HTMLElement> TripMapController.dayPickerTarget(): StimulusProperty<T> =
    StimulusProperty("dayPickerTarget")

public fun <T : HTMLElement> TripMapController.dayPickerTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("dayPickerTargets")

public fun <T : HTMLElement> TripMapController.cityPickerTarget(): StimulusProperty<T> =
    StimulusProperty("cityPickerTarget")

public fun <T : HTMLElement> TripMapController.cityPickerTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("cityPickerTargets")

public fun <T : HTMLElement> TripMapController.cityButtonTarget(): StimulusProperty<T> =
    StimulusProperty("cityButtonTarget")

public fun <T : HTMLElement> TripMapController.cityButtonTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("cityButtonTargets")

public fun TripMapController.zoomValue(): StimulusProperty<Double> = StimulusProperty("zoomValue")

public fun TripMapController.hasZoomValue(): Boolean {
  println(this.asDynamic()["hasZoomValue"])
  return this.asDynamic()["hasZoomValue"]
}

public fun TripMapController.initialModeValue(): StimulusProperty<String> =
    StimulusProperty("initialModeValue")

public fun TripMapController.hasInitialModeValue(): Boolean {
  println(this.asDynamic()["hasInitialModeValue"])
  return this.asDynamic()["hasInitialModeValue"]
}

public fun TripMapController.initialLatValue(): StimulusProperty<String> =
    StimulusProperty("initialLatValue")

public fun TripMapController.hasInitialLatValue(): Boolean {
  println(this.asDynamic()["hasInitialLatValue"])
  return this.asDynamic()["hasInitialLatValue"]
}

public fun TripMapController.initialLngValue(): StimulusProperty<String> =
    StimulusProperty("initialLngValue")

public fun TripMapController.hasInitialLngValue(): Boolean {
  println(this.asDynamic()["hasInitialLngValue"])
  return this.asDynamic()["hasInitialLngValue"]
}

public fun registerTripMapController(stimulus: Application) {
               val clazz = TripMapController::class
               val properties = object  {
                  // Js name needed otherwise Kotlin will mangle the name
                  @JsName("targets")
                  val targets = js("""[
  "map",
  "itineraryPoint",
  "placePoint",
  "itineraryButton",
  "placesButton",
  "dayButton",
  "dayPicker",
  "cityPicker",
  "cityButton",
  ]""")

                  @JsName("values")
                  val values = buildValues(
                      setOf(
                          ValueDefinition("zoom", "Number", false),
  ValueDefinition("initialMode", "String", false),
  ValueDefinition("initialLat", "String", false),
  ValueDefinition("initialLng", "String", false)
                      ),
                      TripMapController.Values
                  )
                  
                  
                  
                  @JsName("classes")
                  val classes = js("[]")
              }

              val factoryFunc = clazz.js.asDynamic()

              addStaticMembersTo(factoryFunc, properties)
              val controllerName = "tripmap"
              println("Registering controller tripmap")

              stimulus.register(controllerName, factoryFunc)
}
